import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DmrlFilterComponent } from '../../components/dmrl/dmrl-filter/dmrl-filter.component';
import { DmrlGridComponent } from '../../components/dmrl/dmrl-grid/dmrl-grid.component';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { DMRLFilterForm } from '../../form-model/dmrl-filter-form.model';
import { WorkOrderSearchTextForm } from '../../form-model/work-order-search-text.form.model';
import { DmrlSearchComponent } from '../../components/dmrl/dmrl-search/dmrl-search.component';

@Component({
  selector: 'app-conatainer-mrl',
  imports: [DmrlFilterComponent, DmrlGridComponent, ReactiveFormsModule, DmrlSearchComponent],
  templateUrl: './conatainer-mrl.component.html',
  styleUrl: './conatainer-mrl.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConatainerMrlComponent {
  filterFormGroup = this.formBuilder.group({
    dmrlFilterForm: this.formBuilder.group<DMRLFilterForm>({} as DMRLFilterForm),
    workOrderSearchTextForm: this.formBuilder.group<WorkOrderSearchTextForm>({} as WorkOrderSearchTextForm),
  });
  constructor(private formBuilder: FormBuilder) {}
}
